/* Bonheur — grid "Yorumlar" popup.
   Renders a product's reviews in the same format as the PDP (pdp-review-item + review-stars
   classes, already styled in base.css). Data: per product from /products/<handle>?view=reviews-json
   (same metafield as the PDP, refreshed nightly); the static product-reviews.json asset is only
   the fallback — it is generated by hand and went months stale (button said 113, popup was empty).
   All user text is inserted via textContent (never innerHTML) to stay XSS-safe. */
(function () {
  'use strict';

  var I18N = (window.CARD_REVIEWS_I18N || {});
  var TXT_VERIFIED = I18N.verified || 'Onaylı alışveriş';
  var TXT_EMPTY = I18N.empty || 'Henüz değerlendirme yok';
  var TXT_CLOSE = I18N.close || 'Kapat';
  var TXT_MORE = I18N.load_more || 'Daha fazla göster';
  var TXT_LOADING = I18N.loading || 'Yükleniyor…';
  var JSON_URL = window.REVIEWS_JSON_URL || '/apps/nope';
  var BATCH = 10;

  var dataPromise = null;   // lazy, cached (fallback asset)
  var perProduct = {};      // handle → promise of that product's review list
  var openSeq = 0;          // guards against a slow response landing in a later product's popup
  var modal = null;
  var pending = [];         // ordered reviews not yet appended

  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }

  function loadData() {
    if (!dataPromise) {
      dataPromise = fetch(JSON_URL, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('reviews json ' + r.status); return r.json(); })
        .catch(function (err) { dataPromise = null; throw err; }); // allow retry on failure
    }
    return dataPromise;
  }

  function loadFor(handle, url) {
    if (!perProduct[handle]) {
      var fresh = !url
        ? Promise.reject(new Error('no product url'))
        // No Accept: application/json here — with it Shopify ignores ?view= and returns the product JSON.
        : fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=reviews-json')
            .then(function (r) { if (!r.ok) throw new Error('reviews view ' + r.status); return r.text(); })
            .then(function (txt) {
              var items = JSON.parse(txt); // not a bare array (HTML, null) → throws → asset fallback
              if (!Array.isArray(items) || !items.length) throw new Error('reviews view empty');
              return items;
            });
      perProduct[handle] = fresh
        .catch(function (err) {
          console.warn('[card-reviews] per-product load failed, using asset', err);
          return loadData().then(function (all) { return all[handle] || []; });
        })
        .catch(function (err) { delete perProduct[handle]; throw err; }); // allow retry on failure
    }
    return perProduct[handle];
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-reviews]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-review-handle');
    if (!handle) return;
    var info = {
      title: btn.getAttribute('data-review-title') || '',
      count: btn.getAttribute('data-review-count') || '',
      avg: parseFloat(btn.getAttribute('data-review-avg')) || 0,
      image: btn.getAttribute('data-review-image') || '',
      price: btn.getAttribute('data-review-price') || '',
      url: btn.getAttribute('data-review-url') || ''
    };

    open(info); // open shell immediately (loading)
    var seq = ++openSeq;
    loadFor(handle, info.url)
      .then(function (items) { if (seq === openSeq) renderList(items); })
      .catch(function (err) {
        console.error('[card-reviews] load failed', err);
        if (seq === openSeq) renderList([]);
      });
  });

  function open(info) {
    if (!modal) modal = build();
    // Product card in the header: image + name + price + stars + count.
    var link = modal.querySelector('[data-crm-product]');
    if (info.url) { link.setAttribute('href', info.url); } else { link.removeAttribute('href'); }
    var thumb = modal.querySelector('[data-crm-thumb]');
    if (info.image) { thumb.src = info.image; thumb.style.display = ''; } else { thumb.removeAttribute('src'); thumb.style.display = 'none'; }
    modal.querySelector('[data-crm-title]').textContent = info.title;
    var priceEl = modal.querySelector('[data-crm-price]');
    priceEl.textContent = info.price || '';
    priceEl.style.display = info.price ? '' : 'none';
    var head = modal.querySelector('[data-crm-stars]');
    head.textContent = '';
    head.appendChild(stars(info.avg));
    var cnt = modal.querySelector('[data-crm-count]');
    cnt.textContent = info.count ? formatCount(info.count) : '';
    modal.querySelector('[data-crm-more]').hidden = true;
    var list = modal.querySelector('[data-crm-list]');
    list.textContent = '';
    var loading = el('li', 'crm-modal__empty');
    loading.textContent = TXT_LOADING;
    list.appendChild(loading);
    lockScroll();                  // lock BEFORE showing so the page doesn't visibly jump
    modal.classList.add('is-open');
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    unlockScroll();
    document.removeEventListener('keydown', onKey);
  }

  // Body scroll-lock KULLANMA (kırmızı kural): position:fixed kilidi +
  // html{scroll-behavior:smooth} birleşince kapanışta sayfa tepeye zıplayıp
  // aşağı kayıyordu. Hapis CSS'le: __body overscroll-behavior:contain,
  // __overlay touch-action:none (card-reviews-modal.css).
  function lockScroll() {}
  function unlockScroll() {}

  function onKey(e) {
    if (e.key !== 'Escape') return;
    if (photoBox && photoBox.classList.contains('is-open')) closePhoto();
    else close();
  }

  // ---- Review photo lightbox (click a thumbnail to enlarge) ----
  var photoBox = null;
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-crm-photo]');
    if (!thumb) return;
    e.preventDefault();
    openPhoto(thumb.getAttribute('data-crm-photo'));
  });

  function openPhoto(src) {
    if (!src) return;
    if (!photoBox) {
      photoBox = el('div', 'crm-photo');
      var ov = el('div', 'crm-photo__overlay');
      ov.addEventListener('click', closePhoto);
      var cls = el('button', 'crm-photo__close');
      cls.type = 'button'; cls.textContent = '×';
      cls.setAttribute('aria-label', TXT_CLOSE);
      cls.addEventListener('click', closePhoto);
      var img = el('img', 'crm-photo__img');
      img.setAttribute('data-crm-photo-img', '');
      photoBox.appendChild(ov); photoBox.appendChild(cls); photoBox.appendChild(img);
      document.body.appendChild(photoBox);
    }
    // Show full resolution (Judge.me/Trendyol thumbnails carry a width token).
    photoBox.querySelector('[data-crm-photo-img]').src = String(src).replace('w=256', 'w=1024');
    photoBox.classList.add('is-open');
  }
  function closePhoto() { if (photoBox) photoBox.classList.remove('is-open'); }

  function build() {
    var m = el('div', 'crm-modal');
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');

    var ov = el('div', 'crm-modal__overlay');
    ov.addEventListener('click', close);

    var panel = el('div', 'crm-modal__panel');

    var closeBtn = el('button', 'crm-modal__close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', TXT_CLOSE);
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', close);

    // Header = a mini product card (image + name + price + rating).
    var header = el('div', 'crm-modal__header');
    var product = el('a', 'crm-modal__product'); product.setAttribute('data-crm-product', '');
    var thumb = el('img', 'crm-modal__thumb'); thumb.setAttribute('data-crm-thumb', ''); thumb.loading = 'lazy'; thumb.alt = '';
    var pinfo = el('div', 'crm-modal__pinfo');
    var h = el('span', 'crm-modal__title'); h.setAttribute('data-crm-title', '');
    var price = el('span', 'crm-modal__price'); price.setAttribute('data-crm-price', '');
    var meta = el('div', 'crm-modal__meta');
    var st = el('span'); st.setAttribute('data-crm-stars', '');
    var ct = el('span', 'crm-modal__count'); ct.setAttribute('data-crm-count', '');
    meta.appendChild(st); meta.appendChild(ct);
    pinfo.appendChild(h); pinfo.appendChild(price); pinfo.appendChild(meta);
    product.appendChild(thumb); product.appendChild(pinfo);
    header.appendChild(product);

    var body = el('div', 'crm-modal__body');
    var list = el('ul', 'pdp-reviews__list'); list.setAttribute('data-crm-list', '');
    body.appendChild(list);

    var more = el('button', 'btn btn--outline crm-modal__more');
    more.type = 'button';
    more.setAttribute('data-crm-more', '');
    more.textContent = TXT_MORE;
    more.hidden = true;
    more.addEventListener('click', appendBatch);
    body.appendChild(more);

    panel.appendChild(closeBtn);
    panel.appendChild(header);
    panel.appendChild(body);
    m.appendChild(ov);
    m.appendChild(panel);
    document.body.appendChild(m);
    return m;
  }

  function renderList(items) {
    var list = modal.querySelector('[data-crm-list]');
    var more = modal.querySelector('[data-crm-more]');
    list.textContent = '';
    pending = [];
    if (!items || !items.length) {
      more.hidden = true;
      var empty = el('li', 'crm-modal__empty');
      empty.textContent = TXT_EMPTY;
      list.appendChild(empty);
      return;
    }
    // Same ordering as the PDP snippet: 4★+ and long (>=100 chars) first, then the rest.
    // ALL reviews are included; revealed in batches via "Daha fazla göster".
    var featured = [], rest = [];
    items.forEach(function (it) {
      ((it.r >= 4 && (it.b || '').length >= 100) ? featured : rest).push(it);
    });
    pending = featured.concat(rest);
    appendBatch();
  }

  function appendBatch() {
    var list = modal.querySelector('[data-crm-list]');
    var more = modal.querySelector('[data-crm-more]');
    pending.splice(0, BATCH).forEach(function (it) { list.appendChild(reviewItem(it)); });
    more.hidden = pending.length === 0;
  }

  function reviewItem(it) {
    var li = el('li', 'pdp-review-item');

    var head = el('div', 'pdp-review-item__head');
    var avatar = el('span', 'pdp-review-item__avatar');
    avatar.setAttribute('aria-hidden', 'true');
    avatar.textContent = (it.n || '?').charAt(0).toUpperCase();
    var name = el('span', 'pdp-review-item__name');
    name.textContent = it.n || '—';
    head.appendChild(avatar);
    head.appendChild(name);
    head.appendChild(stars(it.r));
    if (it.v) {
      var vf = el('span', 'pdp-review__verified');
      vf.textContent = TXT_VERIFIED;
      head.appendChild(vf);
    }
    if (it.d) {
      var dt = el('span', 'crm-review-date');
      dt.textContent = formatDate(it.d);
      head.appendChild(dt);
    }
    li.appendChild(head);

    // Rating-only reviews have no text — skip the empty paragraph so the card stays clean.
    if (it.b && it.b.trim()) {
      var body = el('p', 'pdp-review-item__body');
      body.textContent = it.b;
      li.appendChild(body);
    }

    if (it.p) {
      var pbtn = el('button', 'pdp-review__photo');
      pbtn.type = 'button';
      pbtn.setAttribute('data-crm-photo', String(it.p)); // full-size src for the lightbox
      var img = el('img');
      img.loading = 'lazy';
      img.src = String(it.p).replace('w=1024', 'w=256');
      img.alt = it.n || '';
      pbtn.appendChild(img);
      li.appendChild(pbtn);
    }
    return li;
  }

  function stars(rating) {
    var r = Math.max(0, Math.min(5, parseFloat(rating) || 0));
    var wrap = el('span', 'review-stars review-stars--sm');
    wrap.setAttribute('role', 'img');
    var s = el('span', 'review-stars__stars');
    s.setAttribute('aria-hidden', 'true');
    var track = el('span', 'review-stars__track'); track.textContent = '★★★★★';
    var fill = el('span', 'review-stars__fill'); fill.textContent = '★★★★★';
    fill.style.width = (r / 5 * 100) + '%';
    s.appendChild(track); s.appendChild(fill);
    wrap.appendChild(s);
    return wrap;
  }

  function formatCount(count) {
    var tpl = I18N.count_format || '__N__';
    return tpl.replace('__N__', count);
  }

  // "2026-03-22" -> "22.03.2026" (guard against unexpected formats).
  function formatDate(d) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d));
    return m ? (m[3] + '.' + m[2] + '.' + m[1]) : String(d);
  }
})();
